import { render } from "./CollectionsList.vue?vue&type=template&id=033e0354&scoped=true"
import script from "./CollectionsList.vue?vue&type=script&lang=js"
export * from "./CollectionsList.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=033e0354&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033e0354"]])

export default __exports__